// extracted by mini-css-extract-plugin
module.exports = {"root":"Flyer_root__Y105x","item":"Flyer_item__3NbDK","icon":"Flyer_icon__1eINt","title":"Flyer_title__1VLso","text":"Flyer_text__3zIb_"};